/* eslint-disable react/no-unknown-property */
import React from 'react'
import { SvgIcon, SvgIconProps } from '@material-ui/core'

export const CompletedIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon width='28' height='28' viewBox='0 0 28 28' fill='none' {...props}>
      <circle cx='14' cy='14' r='14' fill='#05C370' />
      <path fillRule='evenodd' clipRule='evenodd' d='M11.8633 20C11.5873 20 11.3233 19.886 11.1343 19.685L6.27126 14.506C5.89226 14.104 5.91326 13.471 6.31526 13.093C6.71826 12.715 7.35126 12.735 7.72826 13.137L11.8533 17.528L20.2613 8.32601C20.6353 7.91701 21.2673 7.89001 21.6753 8.26201C22.0823 8.63401 22.1103 9.26701 21.7383 9.67401L12.6013 19.674C12.4143 19.88 12.1483 19.998 11.8703 20H11.8633Z' fill='white' />
      <mask id='completed-icon' mask-type='alpha' maskUnits='userSpaceOnUse' x='5' y='8' width='17' height='12'>
        <path fillRule='evenodd' clipRule='evenodd' d='M11.8633 20C11.5873 20 11.3233 19.886 11.1343 19.685L6.27126 14.506C5.89226 14.104 5.91326 13.471 6.31526 13.093C6.71826 12.715 7.35126 12.735 7.72826 13.137L11.8533 17.528L20.2613 8.32601C20.6353 7.91701 21.2673 7.89001 21.6753 8.26201C22.0823 8.63401 22.1103 9.26701 21.7383 9.67401L12.6013 19.674C12.4143 19.88 12.1483 19.998 11.8703 20H11.8633Z' fill='white' />
      </mask>
      <g mask='url(#completed-icon)'>
        <rect x='2' y='2' width='24' height='24' fill='white' />
      </g>
    </SvgIcon>
  )
}
